var React = require('react');

function PinInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_83","data-name":"Path 83","d":"M23.074-28.23A8.951,8.951,0,0,0,16.5-30.937,8.951,8.951,0,0,0,9.926-28.23a8.951,8.951,0,0,0-2.707,6.574,20.016,20.016,0,0,0,2.32,8.121A55.5,55.5,0,0,0,14.18-5.35L16.5-2.062Q17.531-3.48,19.078-5.7A62.912,62.912,0,0,0,23.2-13.181q2.578-5.253,2.578-8.476A8.951,8.951,0,0,0,23.074-28.23Zm-4.447,8.766a2.882,2.882,0,0,1-2.127.838,2.932,2.932,0,0,1-2.159-.87,2.932,2.932,0,0,1-.87-2.159,2.932,2.932,0,0,1,.87-2.159,2.932,2.932,0,0,1,2.159-.87,2.932,2.932,0,0,1,2.159.87,2.932,2.932,0,0,1,.87,2.159A2.984,2.984,0,0,1,18.627-19.465Z","transform":"translate(-7.219 30.938)","fill":"#f7f7f7"}));
}

PinInline.defaultProps = {"width":"18.563","height":"28.875","viewBox":"0 0 18.563 28.875"};

module.exports = PinInline;

PinInline.default = PinInline;
